import { Eye, TrendingUp } from 'lucide-react'
import * as React from 'react'

import { cn } from '@/lib/utils'

import ViewStatsDisplay from '@/components/common/view-stats-display'
import ViewTracker from '@/components/common/view-tracker'

interface BlogViewStatsProps {
  blogId: string | number
  className?: string
  showIcon?: boolean
  showTrending?: boolean
  showUniqueOnly?: boolean
  compact?: boolean
  showUnique?: boolean
  onViewTracked?: () => void
}

export const BlogViewStats: React.FC<BlogViewStatsProps> = ({
  blogId,
  className = '',
  showIcon = true,
  showTrending = false,
  showUniqueOnly = false,
  compact = false,
  showUnique = true,
  onViewTracked,
}) => {
  const blogIdString = blogId.toString()

  return (
    <div className={cn('flex items-center gap-2', className)}>
      <ViewTracker
        entityType="blog"
        entityId={blogIdString}
        autoTrack={true}
        onTrackSuccess={onViewTracked}
        windowHours={12}
      />

      <div className="flex items-center gap-1.5">
        {showIcon && <Eye className="h-4 w-4 text-gray-500" />}

        <span className="text-sm text-gray-600">
          {compact ? (
            <ViewStatsDisplay
              entityType="blog"
              entityId={blogIdString}
              showTotal={!showUniqueOnly}
              showUnique={showUnique}
              showWindow={false}
              className="font-medium"
              loadingText="..."
              errorText="--"
            />
          ) : (
            <>
              <span className="mr-1">Views:</span>
              <ViewStatsDisplay
                entityType="blog"
                entityId={blogIdString}
                showTotal={!showUniqueOnly}
                showUnique={showUnique}
                showWindow={showTrending}
                className="font-medium"
                loadingText="Loading..."
                errorText="Unavailable"
              />
            </>
          )}
        </span>

        {showTrending && <TrendingUp className="h-3 w-3 text-green-500" />}
      </div>
    </div>
  )
}

export default BlogViewStats
